/**
 * 认证相关API
 */
import api from './api';

export interface RegisterRequest {
  username: string;
  email: string;
  password: string;
  full_name?: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  success?: boolean;
  access_token: string;
  token_type: string;
  user: UserInfo;
}

export interface RegisterResponse {
  success: boolean;
  message: string;
  user: UserInfo;
}

export interface UserInfo {
  id: number;
  username: string;
  email: string;
  full_name?: string;
  role: string;
  is_active: boolean;
  subscription_expiry?: string | null;
  words_quota?: number | null;
  words_used?: number;
  created_at: string;
}

export const authApi = {
  // 用户注册（注册后需要手动登录）
  register: (data: RegisterRequest) =>
    api.post<RegisterResponse>('/api/auth/register', data),

  // 用户登录
  login: (data: LoginRequest) =>
    api.post<LoginResponse>('/api/auth/login', data),

  // 获取当前用户信息
  getMe: () =>
    api.get<UserInfo>('/api/auth/me'),

  // 更新用户信息
  updateProfile: (data: Partial<UserInfo>) =>
    api.put<UserInfo>('/api/auth/me', data),

  // 修改密码（需验证当前密码）
  changePassword: (data: { current_password: string; new_password: string }) =>
    api.post<{ success: boolean; message?: string }>('/api/auth/change-password', data),

  // 密码重置
  resetPassword: (data: { username: string; email: string; new_password: string }) =>
    api.post('/api/auth/reset-password', data),
};
